<template>
  <div class="col q-mini-drawer-hide">
    <q-list separator class="tree tree--default tree--full-height">
      <item-link v-for="objectGroup in objectGroups.data" :key="objectGroup.id"
                 :href="$route('object-group.edit', {objectGroup: objectGroup.id, page: objectGroups.current_page })"
                 :active="current === objectGroup.id"
      >
        <div class="row items-center position-relative" :class="{'q-pl-md': $isDesktop }">
          {{ objectGroup.title }}
        </div>
      </item-link>
      <q-item v-if="objectGroups.last_page > 1" class="flex flex-center">
        <pagination-links :items="objectGroups" />
      </q-item>
    </q-list>
  </div>
</template>

<script>
export default {
  props: {
    objectGroups: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    current () {
      const id = this.$route().params.objectGroup
      if (!id) return null
      return parseInt(id)
    },
  },
}
</script>
